<template>
    <div class="animated fadeIn" v-if="satisfiedDependencies">
        <b-row class="py-2">
            <b-card header="Nueva Categoría de Consulta" class="w-100">
                <query-category-form
                    :queryCategory="queryCategory"
                    :queryCategories="queryCategories"
                    :renderDeleteButton="false"
                    :renderSaveButton="mixinCheckPermission('QUERY_CATEGORY_NEW')"
                    @submit-query-category="addQueryCategory($event)">
                </query-category-form>
            </b-card>
        </b-row>
    </div>
</template>

<script>
    import QueryCategoryForm from '@/components/queries/categories/QueryCategoryForm';
    import {
        getQueryCategories,
        createQueryCategory
    } from '@/api/query-category-api';

    export default {
        name: "edit-query-category",
        components: {
            QueryCategoryForm
        },
        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getQueryAnswerTypes();
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Volver',
                        path: '/queries/categories/list',
                        brand: 'fa fa-arrow-left'
                    },
                ],
                queryCategories: [],
                queryCategoriesRequestDone: false,
                queryCategory: {
                    uuid: null,
                    name: null,
                    parent: null,
                    children: []
                }
            };
        },
        computed: {
            satisfiedDependencies() {
                return this.queryCategoriesRequestDone;
            }
        },
        methods: {
            async getQueryAnswerTypes() {
                this.$_loadingMixin_showLoading();
                await getQueryCategories()
                    .then((queryCategories) => {
                        this.queryCategories = queryCategories;
                        this.queryCategoriesRequestDone = true;
                    });
                this.$_loadingMixin_hideLoading();
            },
            addQueryCategory(queryCategory) {
                this.$_loadingMixin_showLoading();

                let parentId = null;
                if (!!queryCategory.parent && !!queryCategory.parent.uuid) {
                    parentId = queryCategory.parent.uuid;
                }

                createQueryCategory({
                    name: queryCategory.name,
                    parentId: parentId
                })
                    .then(() => {
                        this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
                        this.$_loadingMixin_hideLoading();
                        this.$router.push({path: '/queries/categories/list'});
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                        this.$_loadingMixin_hideLoading();
                    });
            }
        }
    }
</script>